import validate from "../generated/profile-validator.js";
import { parseSelector } from "./html";
import { dateValue } from "./normalize";
import { fail, type Profile } from "./types";
export function validateProfile(value: unknown): Profile {
  if (!validate(value))
    fail(
      "invalide",
      `Profil invalide : ${JSON.stringify((validate as any).errors)}`,
    );
  const p = value as Profile;
  if (!p.rules.some((r) => r.expected))
    fail("invalide", "Au moins une règle attendue est nécessaire.");
  parseSelector(p.marker);
  if (p.pageUrl) parseSelector(p.pageUrl.selector);
  if (p.timezone) {
    try {
      new Intl.DateTimeFormat("fr", { timeZone: p.timezone });
    } catch {
      fail("invalide", "Fuseau IANA inconnu.");
    }
  }
  if (p.referenceDate) dateValue(p.referenceDate);
  const ids = new Set();
  for (const r of p.rules) {
    if (ids.has(r.id)) fail("invalide", "Identifiant de règle dupliqué.");
    ids.add(r.id);
    parseSelector(r.scope);
    parseSelector(r.selector);
    for (const [k, v] of Object.entries(r.fields || {}))
      if (k !== "keyAttribute") parseSelector(v!);
    if (
      r.reader === "date" &&
      (r.cardinality !== "one" ||
        !["datePublished", "dateModified"].includes(r.property) ||
        !r.policy.dateFormat)
    )
      fail(
        "invalide",
        "Date : cardinalité one, datePublished/dateModified et dateFormat exigés.",
      );
    if (r.reader !== "date" && r.source !== "text")
      fail(
        "invalide",
        "Les lecteurs composés utilisent text et leurs sous-champs déclarés.",
      );
    if (
      r.reader === "authors" &&
      (!r.fields?.name ||
        !r.fields.url ||
        !r.policy.order ||
        r.property !== "author")
    )
      fail(
        "invalide",
        "Auteurs : sélecteurs name/url, ordre et propriété author exigés.",
      );
    if (
      r.reader === "breadcrumb" &&
      (!r.fields?.name ||
        !r.fields.url ||
        r.cardinality !== "sequence" ||
        !r.policy.lastUnlinked ||
        r.property !== "itemListElement")
    )
      fail(
        "invalide",
        "Fil : sélecteurs name/url, séquence, politique dernier lien et itemListElement exigés.",
      );
    if (
      r.reader === "faq" &&
      (!r.fields?.question ||
        !r.fields.answer ||
        !r.policy.faqKey ||
        r.property !== "mainEntity" ||
        (r.policy.faqKey === "identifier" && !r.fields.keyAttribute))
    )
      fail(
        "invalide",
        "FAQ : question, réponse, appariement explicite et mainEntity exigés.",
      );
  }
  return p;
}
